import { getNearestFiveMinTime } from '@lean-body/src/util';
import { CourseVolume, Style, Goal, Lesson } from '.';
export class Course {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nameWithNewLine", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "recommendText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "minTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "goals", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "genres", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "volumes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentCourseDayLesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thumbnailSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.nameWithNewLine = data.nameWithNewLine;
        this.description = data.description;
        this.recommendText = data.recommendText;
        this.thumbnailSrc = data.thumbnailSrc;
        this.minTime = data.minTime;
        this.maxTime = data.maxTime;
        this.selected = data.selected;
        this.goals = data.goals.map((v) => new Goal(v));
        this.genres = data.styles.map((v) => new Style(v));
        this.volumes = data.volumes.map((v) => new CourseVolume(v, config));
        this.lessons = data.sampleLessons ? data.sampleLessons.map((v) => new Lesson(v, config)) : [];
        this.currentCourseDayLesson = data.currentCourseDayLesson ? new Lesson(data.currentCourseDayLesson, config) : null;
    }
    static getDefaultTime(padHours = true) {
        const nearestFiveMin = getNearestFiveMinTime();
        let hour = nearestFiveMin.getHours().toString();
        if (padHours) {
            hour = hour.padStart(2, '0');
        }
        const minute = nearestFiveMin.getMinutes().toString().padStart(2, '0');
        return `${hour}:${minute}`;
    }
    get currentVolume() {
        return this.volumes.find((volume) => !volume.isCompleted);
    }
    thumbnailURL(config) {
        return config.cdnBaseURL + this.thumbnailSrc;
    }
    static sampleCourse(config) {
        return new Course({
            id: 1,
            name: 'ダイエットコース',
            goals: [],
            styles: [],
            volumes: [],
            sampleLessons: [],
        }, config);
    }
}
